var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "show__wrapper" }, [
    _c(
      "div",
      { staticStyle: { transform: "scale(1.12)" } },
      [
        _c(
          "div",
          {
            staticClass: "imageWrapper",
            style: {
              background: _vm.backgroundGradient,
              paddingBottom: 100 * _vm.image.ImgData.ratio + "%",
              marginBottom: "24px",
              borderRadius: "8px"
            }
          },
          [
            _c("div", {
              staticClass: "imageWrapper",
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "url(" + _vm.image.Img400 + ")",
                backgroundSize: "cover",
                filter: "blur(10px)",
                transform: "translate(0, 3%) scale(0.98)"
                // overflow: 'hidden',
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [{ name: "imageloaded", rawName: "v-imageloaded" }],
              staticClass: "show__image",
              attrs: { src: _vm.image.Img400, alt: _vm.show.TITLE }
            })
          ]
        ),
        _vm._v(" "),
        _vm.show.CLASSIFICATION
          ? _c("Movie-ratings", {
              staticClass: "showTitle__ageRating",
              attrs: {
                width: 30,
                icon: _vm.show.CLASSIFICATION.toLowerCase().replace(
                  /\+| - pending/gi,
                  ""
                )
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "showTitle" }, [
      _c("div", { staticClass: "showTitle__header" }, [
        _vm.show.TYPE ? _c("h6", [_vm._v(_vm._s(_vm.show.TYPE))]) : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "showTitle__title" }, [
          _vm._v(_vm._s(_vm.show.TITLE))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.show.CHANNEL))]),
    _vm._v(" "),
    _c(
      "p",
      _vm._l(_vm.themes, function(theme, i) {
        return _c(
          "span",
          {
            key: _vm.show.TITLE.replace(/\s+/gi, "-") + "-" + theme + "-" + i,
            class: {
              theme: true,
              theme__match:
                _vm.votes &&
                _vm.votes.find(function(v) {
                  return v === theme
                })
            }
          },
          [_c("i", [_vm._v(_vm._s(theme))])]
        )
      })
    ),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.show.SYNOPSIS))]),
    _vm._v(" "),
    _vm.show["GOT TALENT"].length
      ? _c("p", [
          _c("b", [_vm._v("GoT stars:")]),
          _vm._v(" " + _vm._s(_vm.show["GOT TALENT"]) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-686b1ae4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686b1ae4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/got-show-matcher/show-card.vue
// module id = null
// module chunks = 